<template>
  <Dialog
    v-model:visible="visible"
    :header="'Image Widget'"
    :modal="true"
    class="w-full max-w-3xl"
  >
    <Tabs v-model:value="activeTab">
      <TabList>
        <Tab :value="0">
          Upload Image
        </Tab>
        <Tab :value="1">
          Browse
        </Tab>
        <Tab :value="2">
          Logo
        </Tab>
      </TabList>
      <TabPanels>
        <!-- Upload Image -->
        <TabPanel :value="0">
          <UploaderPrivateStorage
            ref="uploaderRef"
            v-model:isSubmitting="isSubmitting"
            v-model:folderId="cimFolderId"
            v-model:uploadedFiles="uploadedImages"
            :multipleFilesUpload="false"
            :accept="'image/*'"
          />
          <div class="flex justify-end mt-10">
            <Button
              :label="mode == 'Edit' ? 'Replace' : 'Upload'"
              :loading="isSubmitting"
              @click="uploadFile"
            />
          </div>
        </TabPanel>

        <!-- Browse -->
        <TabPanel :value="1">
          <UploaderFolderBrowse
            ref="uploaderFolderBrowserRef"
            v-model:selectedFile="imageObject"
          />
        </TabPanel>

        <TabPanel :value="2">
          <div
            v-if="props.logo"
            class="w-full"
          >
            <div class="w-full">
              <img
                :src="props.logo"
                alt="Logo"
                class="h-12 block"
              >
            </div>
            <div class="w-full">
              <Button
                label="Upload"
                :loading="isSubmitting"
                @click="addLogo"
              />
            </div>
          </div>
          <div v-else>
            A logo has not been uploaded for this business yet.
          </div>
        </TabPanel>
      </TabPanels>
    </Tabs>

    <template #footer>
      <!-- <div class="flex justify-end gap-2 pt-4">
        <Button
          label="Cancel"
          variant="outlined"
          @click="closeDialog"
        />
        <Button
          :label="'Upload'"
          :disabled="isSubmitting"
          :loading="isSubmitting"
          @click="handleSubmit"
        />
      </div> -->
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
const visible = defineModel<boolean>('visible', {
  type: Boolean,
  required: false,
  default: false,
})

const imageObject = defineModel<object>('imageObject', {
  type: Object,
  required: false,
  default: {},
})
const mode = defineModel<string>('mode', {
  type: String,
  required: false,
  default: 'CREATE',
})

const props = defineProps(['businessId', 'logo'])
const activeTab = ref(0)
const allFolders = ref([])
const emit = defineEmits(['submit'])
const { getFolderType, getAllFolders } = useFolder()
const { createFolder } = useFolder()

// If the active tab is changed then reset the selected file
watch(activeTab, () => {
  selectedFile.value = null
})

// START When it is active tab 0 (Uploading a new image)
const isSubmitting = ref(false)
const cimFolderId = ref('')
const uploaderRef = ref(null)
const selectedFile = ref()
const uploadedImages = ref([])
const uploadFile = async () => {
  isSubmitting.value = true

  await uploaderRef.value?.upload()
  isSubmitting.value = false
  imageObject.value = uploadedImages.value?.[0]
  // Supabase uploader returns early (no folder / no file), leaving the result
  // empty — skip widget creation so we never emit an undefined image.
  if (!imageObject.value) return
  if (mode.value == 'CREATE') {
    createImageWidget()
  }
  else if (mode.value == 'EDIT') {
    // Just close the modal
    visible.value = false
  }
}
// END When it is active tab 0 (Uploading a new image)

// START when it is browse tab
watch(imageObject, async (newImagObject, oldImageObject) => {
  if (newImagObject) {
    if (activeTab.value == 1 && mode.value == 'CREATE') {
      // if there is a new image object in the browse tab then we simply push this change to the image widget
      createImageWidget()
    }
    else if (activeTab.value == 1 && mode.value == 'EDIT') {
      // Just close the modal
      visible.value = false
    }
  }
})
// END when it is browse tab

// START when it is logo tab
const addLogo = () => {
  imageObject.value = {
    name: 'Logo',
    publicUrl: props.logo,
    type: 'image',
  }
  if (mode.value == 'CREATE') {
    createImageWidget()
  }
  else if (mode.value == 'EDIT') {
    // Just close the modal
    visible.value = false
  }
}
// END when it is logo tab
const getFolders = async () => {
  // get All folders
  const allFoldersRes = await getAllFolders(props.businessId)
  allFolders.value = allFoldersRes.data

  // Find the CIM folder
  const _cimFolderId = allFolders.value?.find(folder => folder.folderType == 'CIM')?.id
  // if (!_cimFolderId) {
  //   const newCIMFolder = await createFolder({
  //     businessId: props.businessId,
  //     name: 'CIM',
  //     type: 'CIM',
  //   })
  //   _cimFolderId = newCIMFolder?.id ?? '-'
  // }
  cimFolderId.value = _cimFolderId
}

onMounted(async () => {
  await getFolders()
})

const createImageWidget = () => {
  emit('submit', imageObject.value)

  // close modal
  visible.value = false
  imageObject.value = null
}
// managing the modal visibility
const showDialog = () => {
  visible.value = true
}
defineExpose({
  showDialog,
})
</script>
